<template>
  <div class="page border-box" :class="(orderAlert==1 || (curritem && curritem.info))?'overflow':''" v-wechat-title="$route.meta.title">
    <div class="swiper-box">
      <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
        <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
          <div class="video-box" v-if="item.isvideo">
            <img class="icon-bf" src="../../assets/icon-bf.png" alt="" v-if="item.isvideo&&!isplay"  @click="playVideo()">
            <img :src="item.imgurl" class="video-bg" v-if="item.isvideo&&!isplay">
            <video :src="item.video" controls @play="videoPlay" preload="meta" :poster="item.imgurl" @pause="videoPause"  id="videoPlay" v-show="item.isvideo&&isplay"></video>
          </div>
          <img class="img" :src="item.imgurl"  @click="toLink(item.link)" width="100%" height="100%" alt="" v-if="!item.isvideo && item.link">
          <img class="img" :src="item.imgurl"  @click="seeImg(item.imgurl,banners)" width="100%" height="100%" alt="" v-if="!item.isvideo && !item.link">

        </div>
      </swiper>
      <div class="swiper-len" v-if="banners&&banners.length>1"><span>{{swiperCurr>banners.length?'1':swiperCurr+1}}</span>/{{banners.length}}</div>
    </div>

    <div class="museum-info border-box">
      <div class="title hide">{{scenicInfo.name}}</div>
      <div class="desc">
        <span class="item-tip is-open">{{todayOK?'今日开放':'今日暂停开放'}}</span>
        <span class="line"></span>
        <span class="item-tip">{{scenicInfo.special}}</span>
      </div>

      <!--<div class="address box" @click="openMap">-->
        <!--<p class="flex l">{{scenicInfo.address}}</p>-->
        <!--<p class="r">地图<img src="../../assets/right04.png" alt=""></p>-->
      <!--</div>-->

      <p class="map" @click="openMap">{{scenicInfo.address}}<span class="fr">地图<img class="fr" src="../../assets/right04.png" alt=""></span></p>


      <div class="sub" :class="(subState==0 && scenicInfo.content && scenicInfo.content.length>60)?'hide2':''" v-html="scenicInfo.content" @click="subState=(subState==1?0:1)"></div>

    </div>

    <div class="date-box border-box">
      <div class="date-con">
        <div class="date-item tc" :class="[item.minprice<=0?'disable':'',vtime==item.time?'curr':'']" v-for="(item,index) in nearDaysList" :key="index" @click="selectDate(item.time,index)" v-if="index<7">
          <div class="t">{{item.time|getWeekday}}{{item.time.slice(5)}}</div>
          <div class="b" v-if="item.minprice>0"><span class="price bold">￥<b>{{item.minprice}}</b></span>起</div>
          <div class="b" v-else>不可预约</div>
          <img src="../../assets/checked.png" alt="">
        </div>
      </div>
      <div class="date-item tc date-more" v-if="nearDaysList&&nearDaysList.length>7"  @click="openCalendar">
        <div class="t">更多日期</div>
        <div class="b">查看更多</div>
      </div>
    </div>

    <div class="ticket-box border-box" :class="isNoData?'curr':''">
      <div class="title clearfix"><div class="fl tit-line"><b></b><span>讲解服务</span></div></div>
      <div v-for="(item,index) in prolist" :key="index" v-if="prolist && prolist.length>0">
        <div class="ticket-item border-box box">
          <div class="flex">
            <div class="title">{{item.name}} <font v-if="item.type==2"> ({{item.num}}人团)</font>  </div>
            <div class="ticket-tip clearfix">
              <span class="bor-r">已售{{item.sells|setSellnum}}</span>
              <span class="blue"  @click="OrderknowShow(item,'desc')">预约须知<img class="fr icon-right" src="../../assets/right05.png" alt=""></span><br>
            </div>
            <div class="ticket-tip clearfix">
              <span class="blue bor-r" v-if="item.isOrder">{{vtime|setDatetime}}可订</span>
              <span class="blue bor-r" v-else>{{vtime|setDatetime}}已约满</span>
              <span>讲解时间{{item.hours}}小时</span>
            </div>
          </div>
          <div class="order-desc tc">
            <div class="price tr"><span class="bold">￥<b class="num">{{item.sellprice}}</b></span>起</div>
            <div class="btn btn-s disabled" v-if="item.type==1&&!item.isOrder">已约满</div>
            <div class="btn btn-s linear"  @click="orderAlertFun(item.type-1)" v-if="item.type==1&&item.isOrder">预约</div>

            <div class="btn btn-l disabled" v-if="item.type==2&&!item.isOrder">已约满</div>
            <div class="btn btn-l linear" @click="orderAlertFun(item.type-1)" v-if="item.type==2&&item.isOrder">发起拼团</div>
          </div>
        </div>
        <div class="ticket-group border-box" :class="slideShow==0?'normal':''" v-if="item.type==2 && item.tuans.length>0">
          <div class="ticket-list">
            <div class="item border-box box" v-for="(ite,ind) in item.tuans" :key="ind">
              <div class="l" v-if="ite.peoples && ite.peoples.length>0">
                <img class="tx" :src="ite1.headimg" alt="" v-for="(ite1,ind1) in ite.peoples" :key="ind1" v-if="ind1<3">
                <img class="icon-dian" src="../../assets/icon-dian.png" alt="" v-if="ite.peoples.length>=3">
              </div>
              <div class="m flex tr">
                <span v-if="(item.num-ite.people)>0">还差<font style="color: #fa4f45;">{{item.num - ite.people}}人</font>成团<br></span>
                <span v-else>有用户待支付<br></span>
                {{vtime|setDatetime}}{{ite.stime}}-{{ite.etime}}
              </div>
              <div class="r">
                <div class="btn linear btn-s"  @click="toPreCanOrder(ite.ordernum,item)">去参团</div>
              </div>
            </div>
          </div>
          <div class="more tc" @click="slideFun" v-if="item.tuans.length>3">查看更多<img src="../../assets/down.png" alt=""></div>
        </div>
      </div>
      <div class="ticket-item border-box" v-if="isNoData">
        <p class="cor3 tc">今日暂无讲解服务！</p>
      </div>
    </div>

    <div class="route-box border-box" v-if="routeList&&routeList.length>0">
      <div class="title clearfix">
        <div class="fl tit-line"><b></b><span>讲解线路介绍</span></div>
      </div>

      <div class="route-type border-box">
        <div class="type-item border-box" :class="routeInd==index?'curr':''" @click="selectRoute(index)" v-for="(item,index) in routeList" :key="item.name">
          {{item.name}}
          <img src="../../assets/checked.png" alt="">
        </div>
      </div>

      <div class="route-info border-box">
        <div class="title clearfix">
          <div class="fl name hide">{{routeList[routeInd].title}}</div>
          <div class="fl label" v-if="routeList[routeInd].label">{{routeList[routeInd].label}}</div>
        </div>
        <div class="desc">
          <div class="item box">
            <img src="../../assets/icon-time.png" alt="">
            <div class="name">讲解时间：</div>
            <div class="r hide">{{routeList[routeInd].time}}</div>
          </div>
          <div class="item box">
            <img src="../../assets/icon-dw.png" alt="">
            <div class="name">线路包含：</div>
            <div class="r hide">{{routeList[routeInd].children.length}}个游览点</div>
          </div>
          <div class="item box">
            <img src="../../assets/icon-piao.png" alt="">
            <div class="name">适用票种：</div>
            <div class="r hide" v-if="routeList[routeInd].type==1">VIP套票</div>
            <div class="r hide" v-if="routeList[routeInd].type==2">拼团票</div>
            <div class="r hide" v-if="routeList[routeInd].type==3">VIP套票、拼团票</div>
          </div>
          <div class="item box" v-if="routeList[routeInd].msg">
            <img src="../../assets/tip02.png" alt="">
            <div class="name" style="color: #faaf39;">线路描述：</div>
            <div class="r flex">{{routeList[routeInd].msg}}</div>
          </div>
        </div>
        <div class="route-line" v-if="routeList[routeInd].children && routeList[routeInd].children.length>0">
          <div class="item" v-for="(item,index) in routeList[routeInd].children" :key="item.name">
            <div class="name box">
              <div class="l">{{index+1}}</div>
              <div class="flex r hide">{{item.name}}</div>
            </div>
            <div class="route-img border-box clearfix" :class="(item.logo && item.logo.split(','))?('routeimg'+item.logo.split(',').length):''" v-if="item.logo">
              <img v-lazy="ite" alt="" :key="ite" v-for="(ite,ind) in (item.logo).split(',')">
            </div>
            <!--<div class="line-txt border-box" v-if="item.info" v-html="item.info.replace(/\r\n/g,'<br/>')"></div>-->
            <pre class="line-txt border-box" v-if="item.info" style="white-space: pre-wrap;">{{item.info}}</pre>
          </div>
        </div>
        <div class="route-tip border-box" v-if="routeList[routeInd].children && routeList[routeInd].children.length>0">*以上线路可能会因人员、时间等原因做相应调整，如有不便敬请谅解。</div>
      </div>

    </div>

    <div class="guide-box border-box" v-if="guidelist.length>0">
      <div class="title clearfix">
        <div class="fl tit-line"><b></b><span>讲解员风采</span></div>
        <span class="fr more" v-if="guidelist.length>5" @click="toGuideList">更多<img src="../../assets/right06.png" alt=""></span>
      </div>
      <div class="guide-list">
        <div class="guide-item border-box" @click="toGuide(item.id)" v-for="(item,index) in guidelist" :key="index" v-if="index<5">
          <div class="t-img">
            <img class="img"  v-lazy="item.logo" alt="" :key="item.logo">
          </div>
          <div class="name border-box"><span class="l bold">{{item.name}}</span>
            <!--这个字段不显示-->
            <!--<span class="fr r">6.45万收听</span>-->
          </div>
          <div class="intro box" v-if="item.tag">
            <div class="l">0{{index+1}}</div>
            <div class="flex r hide">{{item.tag}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="comment-box border-box">
      <div class="title clearfix">
        <div class="fl tit-line"><b></b><span>游客评价</span></div>
      </div>
      <div class="comment-item box" v-for="(item,index) in root" :key="index" v-if="root.length>0">
        <img class="l" v-lazy="item.headimg || require('../../assets/icon-tx.png')" alt="">
        <div class="flex r">
          <div class="intro box">
            <div class="flex">
              <div class="hide">{{item.username}}</div>
              <div class="star">
                <template v-for="(star,index) in [1,2,3,4,5]">
                  <img v-if="item.score>=star" src="../../assets/icon-star-curr.png"/>
                  <img v-else  src="../../assets/icon-star.png" />
                </template>
              </div>
            </div>
            <div class="time">{{item.addtime.slice(0,10)}}</div>
          </div>
          <div class="desc" v-if="item.content && item.label">
            <span class="cor-p" v-if="item.label">#{{item.label}}#</span>
            {{item.content.replace('#'+item.label+'#','')}}
          </div>
          <div class="desc" v-else>{{item.content || item.label}}</div>

          <div class="comment-img clearfix" v-if="item.img&&(item.img).split(',').length>0">
            <img class="img" :src="ite" alt="" v-for="(ite,ind) in (item.img).split(',')"  @click="seeComImg(ite,(item.img).split(','))">
          </div>
        </div>
      </div>

      <div class="load-tip">
        <p>
          <span class="l"></span>
          <span class="m">{{loadText}}</span>
          <span class="r"></span>
        </p>
      </div>
    </div>

    <div class="fixed-bottom border-box">
      <div class="fl item-l" @click="toOrder">
        <img src="../../assets/icon-dd.png" alt="">订单
      </div>
      <a class="fl item-l" :href="'tel:'+scenicInfo.contact">
        <img src="../../assets/icon-kf.png" alt="">客服
      </a>
      <div class="fr btn-box">
        <div class="btn linear btn2" @click="orderAlertFun(0)" v-if="hasVip">预约</div>
        <div class="btn linear btn2 disabled"  v-else>预约</div>
        <div class="btn linear btn1"  @click="orderAlertFun(1)" v-if="hasTuan">发起拼团</div>
        <div class="btn linear btn1 disabled"  v-else>发起拼团</div>
      </div>
    </div>


    <div class="alert-box order-alert" v-if="orderAlert==1">
      <div class="mask"  @click="orderAlertFun"></div>
      <div class="alert-con">
        <img class="icon-close" @click="orderAlertFun" src="../../assets/icon-close1.png" alt="">
        <div class="order-alert-top">
          <div class="t1 bold">{{orderItem.name}}</div>
          <div class="t2">已选{{vtime|setDatetime}}出行</div>
        </div>

        <div class="order-alert-mid border-box">
          <div class="tag-list clearfix" v-if="orderItem.type==1 && orderItem.guidetype && JSON.parse(orderItem.guidetype).length>0">
            <div class="tag-tit bold">讲解语言选择</div>
            <div class="fl tag-item hide" :class="guideCode==item.code?'curr':''" @click="guideCode=item.code,getPayTypePriceFun()" v-for="(item,index) in JSON.parse(orderItem.guidetype)" :key="index">{{item.name}}</div>
          </div>
          <div class="tag-list clearfix" v-if="orderItem.times && orderItem.times.length>0">
            <div class="tag-tit bold">预约讲解服务时段 <span style="font: .18rem 'Microsoft YaHei';">(请提前10-20分钟到前台联系讲解员)</span></div>
              <div class="fl tag-item hide" :class="[timeId==item.id?'curr':'',item.show?'':'disabled']"  v-for="(item,index) in orderItem.times" :key="index" @click="item.show?(timeId=item.id,getPayTypePriceFun()):''">{{item.stime}}-{{item.etime}}</div>
          </div>
          <div class="tag-list clearfix" v-if="orderItem.type==1 && orderItem.peopletype && JSON.parse(orderItem.peopletype).length>0">
            <div class="tag-tit bold">使用人数选择</div>
            <div class="fl tag-item hide" :class="peopleCode==item.code?'curr':''" @click="peopleCode=item.code,getPayTypePriceFun()" v-for="(item,index) in JSON.parse(orderItem.peopletype)" :key="index">{{item.name}}</div>
          </div>
          <div class="tag-list clearfix" v-if="orderItem.type==1 && orderItem.rotes && orderItem.rotes.length>0">
            <div class="tag-tit bold">讲解线路选择</div>
            <div class="fl tag-item hide" :class="siteId==item.id?'curr':''" @click="siteId=item.id,getScenicRoteFun(item.id),getPayTypePriceFun()" v-for="(item,index) in orderItem.rotes" :key="index">{{item.name}}</div>
          </div>
          <div class="tag-list clearfix" v-if="orderItem.type==2">
            <div class="tag-tit bold">注：拼团票不可选择线路，由馆方统一安排</div>
          </div>
          <div class="route-box border-box" v-if="(orderItem.type==1 && orderItem.rotes && orderItem.rotes.length>0) && (subscribeInfo&&subscribeInfo.name)" style="padding: 0">
            <div class="route-info border-box">
              <div class="title clearfix">
                <div class="fl name hide">{{subscribeInfo.title}}</div>
                <div class="fl label" v-if="subscribeInfo.label">{{subscribeInfo.label}}</div>
              </div>
              <div class="desc">
                <div class="item box">
                  <img src="../../assets/icon-time.png" alt="">
                  <div class="name">讲解时间：</div>
                  <div class="r hide">{{subscribeInfo.time}}</div>
                </div>
                <div class="item box">
                  <img src="../../assets/icon-dw.png" alt="">
                  <div class="name">线路包含：</div>
                  <div class="r hide">{{subscribeInfo.children.length}}个游览点</div>
                </div>
                <div class="item box">
                  <img src="../../assets/icon-piao.png" alt="">
                  <div class="name">适用票种：</div>
                  <div class="r hide" v-if="subscribeInfo.type==1">VIP套票</div>
                  <div class="r hide" v-if="subscribeInfo.type==2">拼团票</div>
                  <div class="r hide" v-if="subscribeInfo.type==3">VIP套票、拼团票</div>
                </div>
                <div class="item box" v-if="subscribeInfo.price>0">
                  <img src="../../assets/icon-pri.png" alt="">
                  <div class="name">附加价格：</div>
                  <div class="r hide" style="color:#fa4f45;">{{subscribeInfo.price}}元</div>
                </div>
                <div class="item box" v-if="subscribeInfo.msg">
                  <img src="../../assets/tip02.png" alt="">
                  <div class="name" style="color: #faaf39;">线路描述：</div>
                  <div class="r flex">{{subscribeInfo.msg}}</div>
                </div>
              </div>
              <div class="route-line" v-if="subscribeInfo.children && subscribeInfo.children.length>0">
                <div class="item" v-for="(item,index) in subscribeInfo.children" :key="item.name">
                  <div class="name box">
                    <div class="l">{{index+1}}</div>
                    <div class="flex r hide">{{item.name}}</div>
                  </div>
                  <div class="route-img border-box clearfix" :class="(item.logo && item.logo.split(','))?('routeimg'+item.logo.split(',').length):''" v-if="item.logo">
                    <img v-lazy="ite" alt="" :key="ite" v-for="(ite,ind) in (item.logo).split(',')">
                  </div>
                  <pre class="line-txt border-box" v-if="item.info" style="white-space: pre-wrap;">{{item.info}}</pre>
                </div>
              </div>
              <div class="route-tip border-box" v-if="subscribeInfo.children && subscribeInfo.children.length>0">*以上线路可能会因人员、时间等原因做相应调整，如有不便敬请谅解。</div>
            </div>
          </div>
        </div>

        <div class="order-alert-bot bgF box border-box">
          <div class="flex">总价:
            <span class="cor-p">￥<font>{{totalprice}}</font></span>
          </div>
          <div class="btn linear" @click="toPreOrder">预约</div>
        </div>
      </div>
    </div>

    <div class="alert-box alert-ewm" v-if="subscribeShow==1">
      <div class="mask" @click="subscribeShow=0"></div>
      <div class="alert-con">
        <img class="bottom-close" src="../../assets/icon-v-close.png" alt="" @click="subscribeShow=0">
        <p class="ewm-img"><img class="img" :src="subscribeData.ercode" alt=""></p>
        <p class="ewm-txt">长按二维码 关注景区官方公众号 <br/>下单后可及时接收到消息通知</p>
      </div>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
    <P401  v-if="P401==1"></P401>

    <!--日历弹窗-->
    <calendar :selectTime="date" :currentTime="date" :nowTime="date" :daysList="nearDaysList" @sendObj="getCalendarData" v-if="calendarShow==1"></calendar>

    <!--预约须知-->
    <AlertOrderKnow :type="AlertOrderKnowType" :ordernum="AlertOrderKnowOrdernum" :curritem="curritem"  v-if="curritem && curritem.info" v-on:child-orderKnow="closeOrderKnow"></AlertOrderKnow>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import P401 from '../../components/P401'
  import calendar from '../../components/calendar'
  import AlertOrderKnow from '../../components/AlertOrderKnow'
  import {getScenicBanner, getScenicInfo, getScenicCalendar, getScenicProduct, getScenicGuide, getPayTypePrice, getScenicComments, getScenicRotes, getScenicKeySubscribe,getScenicRote} from "@/service/getData";
  import {wxImgPreview,wxGetPosition,wxShareme,wxOpenMapLocation} from '@/utils/wechat'
  import {setStore, getStore, removeStore, setTime, loadMore} from '@/config/mUtils'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      const self = this;
      return {
        userInfo: {}, //用户信息
        P400: 0, //系统维护中
        P401: 0, //授权登录

        swiperCurr:0,
        swiperOption: {
          initialSlide: 0,
          speed: 500,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: true,//开启循环模式
//          autoplay: {
//            delay: 3000,
//            disableOnInteraction: false
//          },
          autoplay: false,
          slidesPerView: 1,
          spaceBetween: 0,
          observeParents:true,
          observer: true,
          preventClicksPropagation: true,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          on: {
            slideChangeTransitionEnd: function () {
              self.swiperCurr = this.activeIndex;
              // 切换结束时，告诉我现在是第几个slide
            }
          }
        },

        orderAlert:0,//预约弹窗显示与隐藏
        orderItem: '', // 当前要预约那种产品
        curritem:0,//预订须知0：隐藏 有信息显示
        slideShow:0,//拼团订单展开与收缩 0：收缩 1：展开

        todayOK: false, //今天客订
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        scenicInfo: '', //景区基本信息
        banners: [], //景区banner图
        routeList: [], //线路信息
        prolist: [], //所选日期的产品数据
        isNoData: false, //是否没有数据
        guidelist: [], //导游数据
        root: [], //评论数据
        page: 1, //加载更多
        pageSize:10,
        loadText: "数据加载中",

        vtime:this.$route.query.vtime || '',//所选日期
        nearDaysList:[],//近30日
        calendarShow: 0, //是否显示日历弹窗
        date: {
          day: '',
          month: '',
          year: ''
        },

        guideCode: '', //选的讲解类型编码
        timeId: '', //选的 讲解时段id
        peopleCode: '', //选的人数类型编码
        siteId: '', //选的线路id
        totalprice: '', //选择规格后最终算出来的价格

        isplay: 0, //视频是否在播放
        routeInd:0,//选择线路

        subscribeShow: 0, //显示公众号二维码
        subscribeData: '', //公众号信息 subscribe:1 已关注
        subscribeInfo: '', //线路信息

        AlertOrderKnowType: 'desc', //常规预约须知弹窗 'rule'下单是弹出的预约须知弹窗
        AlertOrderKnowOrdernum: '', //去参团时的团单号
        isRuleClick: 0, //是否点了预约须知0未点 1点了

        hasVip: 0, //是否有VIP产品
        hasTuan: 0, //是否有团购产品
        subState: 0, //是否展开简介
      }
    },
    computed: {},
    created(){
      if(this.scenicId){
        this.$loading.show('数据加载中');
        this.userInfo = getStore("userInfo");
        var date = new Date();
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var year = date.getFullYear();
        this.date = {
          selectDate: day,
          selectMonth: month,
          selectYear: year,
          day: day,
          month: month,
          year: year
        };

        this.getScenicBannerFun();
        this.getScenicInfoFun();
        this.getScenicCalendarFun();
        this.getScenicGuideFun();
        this.getScenicRotesFun();
        this.getScenicCommentsFun(this.page);

        if(this.scenicKey){
          this.getScenicKeySubscribeFun()
        }


      }else{
        this.P401 = 1
      }

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    beforeRouteLeave(to, from, next){
      window.removeEventListener("scroll",this.handleFun)
      next();
    },
    methods: {
      callback(a){},

      //获取banner数据
      async getScenicBannerFun(){
        let res = await getScenicBanner({
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.banners = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取基本信息
      async getScenicInfoFun(){
        let res = await getScenicInfo({
          scenicId: this.scenicId,
      time: (new Date().getTime())
        })
        if (res.errcode == "00000") {
          this.scenicInfo = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取线路信息
      async getScenicRotesFun(){
        let res = await getScenicRotes({
          scenicId: this.scenicId,
      time: (new Date().getTime())
        })
        if (res.errcode == "00000") {
          this.routeList = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      //判断用户是否关注公共好
      async getScenicKeySubscribeFun(){
        let res = await getScenicKeySubscribe({
          openid: this.userInfo.openid
        })
        if (res.errcode == "00000") {
          this.subscribeData = res.data
        }
      },

      //按照线路id获取线路
      async getScenicRoteFun(siteId){
        let res = await getScenicRote({
          siteId: siteId,
      time: (new Date().getTime())
        })
        if (res.errcode == "00000") {
          this.subscribeInfo = res.data
        }
      },

      //获取景区近期日程 近30天
      async getScenicCalendarFun(){
        let res = await getScenicCalendar({
          days: 30,
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.nearDaysList = res.data;

          var ind = 0,data = res.data;
          var s1 = setTime(new Date()).format('yyyy-MM-dd'); //今天
          for(var i=0; i<7; i++){
            if(data[i].minprice>0){
              ind = 0;
              break;
            }
          }
          if(s1 == data[0].time && data[0].minprice>0){
            this.todayOK = true;
          }else {
            this.todayOK = false;
          }

          //川博周一闭管
          if(setTime(new Date()).getWeek()=='星期一' && this.scenicId==1){
            this.todayOK = false;
          }

          if(!this.vtime){
            this.vtime = data[ind].time;
          }
          this.todayOK = true;//端午节添加
          this.getScenicProductFun();
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取对应日期的产品数据
      async getScenicProductFun(){
        let res = await getScenicProduct({
          date: this.vtime,
          scenicId : this.scenicId,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {

          var list =  res.data;
          if(list.length>0){
            list.forEach(item => {
              var times = item.times;
              item.isOrder = false;
              item.hours = this.calcHours(times[0].sdate,times[0].edate); //计算第一个时间的讲解时长
              times.forEach(ite => {
                if(this.bjDate(ite.sdate) && ite.num>0){
                  ite.show = true;
                  item.isOrder = true;
                }else {
                  ite.show = false;
                }
              })
              if(item.type==2&&item.time==setTime(new Date()).format('yyyy-MM-dd')){
                item.isOrder = false;
              }
              if(item.type==1 && item.isOrder){
                this.hasVip = 1;
              }else {
                this.hasVip = 0;
              }
              if(item.type==2 && item.isOrder){
                this.hasTuan = 1;
              }else {
                this.hasTuan = 0;
              }
            })
          }else {
            this.hasVip = 0;
            this.hasTuan = 0;
          }

          this.prolist = [];
          this.prolist = list;

          if(!list || list.length<=0){
            this.isNoData = true;
          }else {
            this.isNoData = false;
          }

          this.$route.meta.title = this.scenicInfo.name;

          let title = this.scenicInfo.name + ' | 预约讲解';
          let desc = '欢迎使用预约讲解服务系统！';
          let link = '/?scenicId='+this.scenicId+'&scenicKey='+this.scenicKey;
          let img = (this.banners[0]&&this.banners[0].imgurl)?this.banners[0].imgurl:''
          wxShareme(title, desc, img, link);
        }else {
          this.$toast(res.errmsg);
        }
      },

      //判断今日是否可预订
      bjDate: function(date1) {
        var date = new Date();
        if (date1) {
          if (typeof date1 === 'string') {
            date1 = new Date(date1.replace(/-/g, "/"));
          } else if (typeof date1 === 'number') {
            date1 = new Date(date1);
          }
        }

        //<0第二个时间大（今日可订） >0当前（今日不可订）
        return ((date.getTime() - date1.getTime()) < 0);
      },
      //计算时长
      calcHours: function(stime,etime){
        //将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
        stime = stime.replace(/\-/g, "/");
        etime = etime.replace(/\-/g, "/");
        var sTime =new Date(stime); //开始时间
        var eTime =new Date(etime); //结束时间
        return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(1000*3600));
      },

      //获取导游数据
      async getScenicGuideFun(){
        let res = await getScenicGuide({
          pageNum: 1,
          pageSize: 6,
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });
        this.$loading.hide();
        if (res.errcode === '00000') {
          this.guidelist = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取评论数据
      async getScenicCommentsFun(page){
        let res = await getScenicComments({
          pageNum: page,
          pageSize: this.pageSize,
          scenicId: this.scenicId,
      time: (new Date().getTime())
        });
        if (res.errcode === '00000') {
          this.total = res.total
          let root = res.data
          if (page >= Math.ceil(this.total / this.pageSize)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无评论'
            } else {
              this.loadText = '已经到底了'
            }
          }

        }else {
          this.$toast(res.errmsg);
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.getScenicCommentsFun(page);
          });
        })
      },

      //计算价格
      async getPayTypePriceFun(times,ind){
        let res = await getPayTypePrice({
          guideCode: this.guideCode || '',
          peopleCode: this.peopleCode || '',
          siteId: this.siteId || '',
          timeId: this.timeId || '',
          pneed: 0, //是否需要发票
        });
        if (res.errcode == "00000") {
          this.totalprice = res.data;
          if(this.orderAlert==0){
            this.orderAlert = 1;
          }

        }else {
          if(times){
            this.orderItem.times[ind].show = false;
            this.$set(this.orderItem.times, ind, this.orderItem.times[ind]);
            if(ind<this.orderItem.times.length-1){
              var indd = ind+1;
              this.timeId = this.orderItem.times[indd].id;
              this.getPayTypePriceFun(this.orderItem.times,indd);
            }else {
              this.$toast(res.errmsg);
            }
          }else {
            this.$toast(res.errmsg);
          }

        }
      },

      //选择日期
      selectDate(time,index){
        this.vtime = time;
//        this.prolist = [];
        this.getScenicProductFun();
      },

      //监听日历数据
      getCalendarData: function(data) {
        if(data.currentDate){
          var day = (data.currentDate<10 && String(data.currentDate).length<=1) ? '0' + data.currentDate : data.currentDate;
          var month = (data.currentMonth<10 && String(data.currentMonth).length<=1) ? '0' + data.currentMonth : data.currentMonth;
          var year = data.currentYear;

          if (this.date.year != year || this.date.month != month || this.date.day != day){
            this.date = {
              selectDate: day,
              selectMonth: month,
              selectYear: year
            };
          }

          //后加的
          this.vtime = year + '-' + month + '-' + day;

          //点击日期后swiper滚动到相应位置
          var dateArr = [];
          for(var i = 0;i<this.nearDaysList.length;i++){
            dateArr.push(this.nearDaysList[i].vtime)
          }
          var index = dateArr.indexOf(this.vtime);

          this.selectDate(this.vtime,index);
        }

        if(data.calendarShow || data.calendarShow===0){
          this.calendarShow = data.calendarShow;
        }

      },

      //预约须知弹窗隐藏
      closeOrderKnow :function(res){
        this.curritem = res.close;
        this.isRuleClick = res.msg;
        if(res.msg==1 && res.ordernum){
          this.toPreCanOrder(res.ordernum);
        }
      },

      //显示预约须知
      OrderknowShow: function (item,type,ordernum){
        this.curritem = item;
        this.AlertOrderKnowType = type;
        this.AlertOrderKnowOrdernum = ordernum || '';
      },

      //跳转到导游列表页面
      toGuideList(){
        this.$router.push({
          path: `/guide-list?${'scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
      //跳转到导游详情页面
      toGuide(id){
        this.$router.push({
          path: `/guide?${'id='+id+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },
      //跳转到订单页面
      toOrder(){
        this.$router.push({
          path: `/order-list?${'scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //地图导航
      openMap: function (){
        wxOpenMapLocation(this.scenicInfo.lat, this.scenicInfo.lng, this.scenicInfo.name, this.scenicInfo.address)
      },

      //banner图片预览
      seeImg: function(img,imgs){
        var arr = [];
        for(var i=0; i<imgs.length; i++){
          arr.push(imgs[i].imgurl);
        }
        wxImgPreview(img,arr);
      },

      //评论图片预览
      seeComImg:function(img,imgs){
        wxImgPreview(img,imgs);
      },

      //跳转链接
      toLink: function (url){
        window.location = url;
      },

      //预约弹窗
      orderAlertFun:function(ind){ //0包团 1拼团 ''关闭
        var orderItem = this.prolist[ind];
        console.log(orderItem,this.prolist,this.prolist[1]);

        if(this.isRuleClick==1) { //已经点击过“我已阅读”

        }else {
          this.OrderknowShow(orderItem,'rule');
        }

        if(this.orderAlert==0){
          this.guideCode = '';
          this.peopleCode = '';
          this.timeId = '';
          if(orderItem && orderItem.isOrder){
            this.orderItem = orderItem;
            this.guideCode = (orderItem.guidetype && JSON.parse(orderItem.guidetype).length>0)?JSON.parse(orderItem.guidetype)[0].code:'';
            this.peopleCode = (orderItem.peopletype && JSON.parse(orderItem.peopletype).length>0)?JSON.parse(orderItem.peopletype)[0].code:'';
            this.siteId = (orderItem.rotes && orderItem.rotes.length>0)?orderItem.rotes[0].id:'';

            var ind = '';
            for(var i=0; i<orderItem.times.length; i++){
              if(orderItem.times[i].show){
                this.timeId = orderItem.times[i].id;
                ind = i;
                break;
              }
            }
            this.getScenicRoteFun(this.siteId);
            if(this.timeId){
              this.getPayTypePriceFun(orderItem.times,ind);
            }else {
              this.$toast('今日暂无可预订时段！');
            }
          }else{
            this.$toast('今日暂无可预订时段！');
          }
        }else{
          this.orderAlert = 0;
        }

      },

      //展开收缩
      slideFun:function(){
        if(this.slideShow==0){
          this.slideShow = 1;
        }else{
          this.slideShow = 0;
        }
      },

      //点击播放按钮
      playVideo(){
        var Video = document.getElementById("videoPlay");
        if(Video.paused){
          Video.play();
          this.isplay = 1;
        }else {
          Video.pause();
          this.isplay = 0;
        }
      },
      //监听播放与暂停
      videoPlay(){
        this.isplay = 1;
      },
      videoPause(){
        this.isplay = 0;
      },

      //跳转到下单页面
      toPreOrder: function (){
        if(this.scenicKey && this.subscribeData && this.subscribeData.subscribe===0){ //需要关注公众号好
          this.subscribeShow = 1;
        }else {
          var orderItem = this.orderItem;
          if((this.orderItem.type==1 && ((orderItem.guidetype&&JSON.parse(orderItem.guidetype).length>0&&this.guideCode=='') ||
            (orderItem.peopletype&&JSON.parse(orderItem.peopletype).length>0&&this.peopleCode=='') ||
            (orderItem.rotes&&orderItem.rotes.length>0&&this.siteId=='') || this.timeId=='')) || (this.orderItem.type==2 && this.timeId=='')){
            this.$toast('请选择产品规格');
            return;
          }
          this.$router.push({
            path: `/order-create?${'guideCode='+this.guideCode+'&peopleCode='+this.peopleCode+'&siteId='+this.siteId+'&timeId='+this.timeId+'&ptype='+this.orderItem.type+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
          });
        }

      },

      //直接去参团
      toPreCanOrder: function (ordernum,item){
        if(this.isRuleClick==1){ //已经点击过“我已阅读”
          if(this.scenicKey && this.subscribeData && this.subscribeData.subscribe===0){ //需要关注公众号好
            this.subscribeShow = 1;
          }else {
            this.$router.push({
              path: `/order-create?${'ordernum1='+ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
            });
          }
        }else {
          if(item){
            this.OrderknowShow(item,'rule',ordernum);
          }
        }
      },

      //选择线路
      selectRoute:function(index){
        this.routeInd = index;
      },

      //打开日历弹窗
      openCalendar: function (){
        this.calendarShow=1
      },


    },
    watch: {},
    components: {
        P400,calendar,AlertOrderKnow,P401
    },
    //格式化数据
    filters: {
      initDistance: function (num) {
        if (num > 1000) {
          num = (num / 1000).toFixed(2) + 'KM'
        } else{
          num = num.toFixed(2) + 'M'
        }
        return num;
      },
      //计算日期周几
      getWeekday: function(date){
        var weekArray = new Array("周日","周一", "周二", "周三", "周四", "周五", "周六");
        var week  = weekArray[new Date(date).getDay()];

        var s1 = setTime(new Date()).format('yyyy-MM-dd'); //今天
        var s2 = setTime((new Date()).getTime()+24*60*60*1000).format('yyyy-MM-dd'); //明天
        if(date == s1){
          week = '今天'
        }else if(date == s2){
          week = '明天'
        }
        return week;
      },
      //计算日期
      setDatetime: function(time){
        let month = parseInt(time.substring(5,7));
        let date = parseInt(time.substring(8,10));

        var txt = month + '月' + date + '日';

        var s1 = setTime(new Date()).format('yyyy-MM-dd'); //今天
        var s2 = setTime((new Date()).getTime()+24*60*60*1000).format('yyyy-MM-dd'); //明天
        if(time == s1){
          txt = '今天'
        }else if(time == s2){
          txt = '明天'
        }

        return txt;
      },
      //格式化售出个数
      setSellnum: function (num){
        return num>1000?'1000+':num
      },
      //比较两个时间大小
      bjDate: function(date1) {
        var date = new Date();
        var date1 = new Date(date1);
        //<0第二个时间大（今日可订） >0当前（今日不可订）
        if(date.getTime() - date1.getTime() < 0){
          return 1;
        }else{
          return 2;
        }
      },
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  /** {touch-action: pan-y;touch-action: pan-x;}*/
  .page{width: 100vw;padding-bottom:1.2rem;background: #f6f7fb;}
  .btn{height:.56rem;font: .28rem/.56rem "Microsoft YaHei";border-radius: .28rem;text-align: center;}
  .btn-s{width: 1.32rem;}
  .btn-l{width: 1.54rem;}
  .swiper-box{position:relative;width: 100vw;height: 3.8rem;}
  .swiper-container{width: 100%;height: 100%;}
  .swiper-slide .video-box{position: absolute;top:0;left: 0;width: 100%;height: 100%;}
  .swiper-slide .video-bg{position: absolute;top:0;left: 0;z-index: 1;width: 100%;height: 100%;}
  .swiper-slide .icon-bf{position: absolute;top:50%;left: 50%;z-index: 2;width:.8rem;height: .8rem;margin:-.4rem 0 0 -.4rem; }

  .swiper-slide .img{width: 100%;height: 100%;object-fit: cover;}
  .swiper-slide video{width: 100%;height: 100%;object-fit: cover;}
  .swiper-len{position: absolute;right: .24rem;bottom:.4rem;z-index: 1;height: .44rem;padding:0 .22rem;font:.26rem/.44rem "Microsoft YaHei";color:#fff;background: rgba(0,0,0,.5);border-radius: .22rem;}
  .museum-info{position:relative;z-index:1;margin:-.24rem .24rem 0;padding:.4rem .3rem .44rem;background: #fff;border-radius: .2rem;}
  .museum-info .title{font:bold .32rem "Microsoft YaHei";color: #222;}
  .museum-info .desc{margin-top: .2rem;font:.26rem/.36rem "Microsoft YaHei";color:#222; }
  .museum-info .item-tip{font:.26rem/.36rem "Microsoft YaHei";color:#222;}
  .museum-info .item-tip.is-open{color: #26a411;}
  /*.museum-info .item-tip.is-open:after{content: '';position: absolute;right: 0;top: 50%;width: 1px;height: .22rem;margin-top: -.11rem;background: #999;}*/
  .museum-info .line{display: inline-block;width: .02rem;height: .24rem;margin: .06rem .08rem;vertical-align: top;background: #999;}
  .museum-info .address{width:100%;margin-top: .2rem;font:.26rem/.32rem "Microsoft YaHei";color:#222;}
  .museum-info .address p{position: relative;}
  .museum-info .address .r{ margin-left: .3rem;width: 1rem; font: .24rem/.32rem "Microsoft YaHei";color: #0787f2;display: flex; flex-direction: row; justify-content: center; align-items: center; }
  .museum-info .address .r img{float:right;width: auto;height: .24rem;margin-left: .14rem;}

  .museum-info .map{position:relative;z-index:1;margin-top:.1rem;font: .24rem/.36rem "Microsoft YaHei";color:#222;cursor: pointer;}
  .museum-info .map span{color: #0787f2;}
  .museum-info .map img{width: auto;height: .24rem;margin-top: .06rem;margin-left: .14rem;}
  .museum-info .sub{margin-top: .2rem;font:.24rem/.34rem "Microsoft YaHei";color:#666;}
  .museum-info .sub.hide2{height: .68rem;}
  .date-box{position: relative;width: 100%;margin: .2rem 0;padding-left: .24rem;padding-right:1.84rem;}
  .date-box .date-con{width: 100%;overflow: auto;white-space: nowrap;}
  .date-box .date-item{position:relative;display:inline-block;width:1.6rem;height: 1.04rem;margin-right: .2rem;border:.02rem solid #fff;background: #fff;border-radius: .14rem;overflow: hidden;}
  .date-box .date-item.date-more{position: absolute;right: .24rem;top:0;width: 1.4rem;margin: 0;box-shadow: 0 0 0.1rem rgba(193,8,16,.2);}
  .date-box .date-item img{display:none;position: absolute;bottom:-.05rem;right:-.06rem;z-index:1;width: .34rem;height: .31rem}
  .date-box .date-item.curr{border-color: #faaf39;background: #fffaf3;}
  .date-box .date-item.curr img{display: block;}
  .date-box .date-item.disable .t,.date-box .date-item.disable .b{color: #adadad;}
  .date-box .date-item .t{margin-top:.16rem;font-size: .26rem;color: #333;}
  .date-box .date-item .b{margin-top:.08rem;font-size: .2rem;color: #666;}
  .date-box .price{font-size:.24rem;color: #fa4f45;}
  .date-box .price b{margin-right:.03rem;font-size: .3rem;}
  .ticket-box{position:relative;z-index:1;margin: 0 .24rem;padding:.4rem .3rem;background: #fff;border-radius: .2rem;min-height: 3rem;}
  .ticket-box.curr{min-height: 0;}
  .ticket-box .ticket-item{margin-top:.3rem;padding:.3rem .24rem;border-radius: .2rem;background: #fff9f3;}
  .ticket-box .ticket-item .title{font: bold .3rem "Microsoft YaHei";color: #333;padding-bottom: .12rem;}
  .ticket-box .order-desc{align-items: center;}
  .ticket-box .ticket-tip{font: .24rem/.28rem "Microsoft YaHei";color: #666;}
  .ticket-box .ticket-tip span{float: left;margin-top:.14rem;margin-right:.1rem;}
  .ticket-box .ticket-tip span.bor-r{padding-right: .1rem;border-right: .02rem solid #cdcdcd;}
  .ticket-box .blue{color: #0787f2;}
  .ticket-box .icon-right{width: auto;height: .2rem;margin-top:.04rem;margin-left: .1rem;}
  .ticket-box .price{font-size: .2rem;color: #666;}
  .ticket-box .price span{font-size:.28rem;color:#fa4f45;}
  .ticket-box .price .num{font-size: .36rem;margin-right: .02rem;}
  .ticket-box .order-desc .btn{margin-top:.2rem;}
  .ticket-group{margin-top:.02rem;padding: 0 .24rem;border-radius: .2rem;background: #fff9f3;}
  .ticket-group.normal .ticket-list{max-height: 2.52rem;}
  .ticket-group .ticket-list{height:auto;overflow: hidden;}
  .ticket-group .item{width: 100%;height: 1.26rem;padding-top: .4rem;padding-bottom: .3rem;border-bottom:1px solid #ebe5e0;}
  .ticket-group .item .l{width: 1.86rem;margin-right: .1rem;}
  .ticket-group .item .tx{float: left;width: .52rem;height: .52rem;margin-left:-.1rem;border:.02rem solid #fff;border-radius: 50%;overflow: hidden;}
  .ticket-group .item .tx:first-child{margin-left: 0;}
  .ticket-group .item .icon-dian{width: auto;height: .06rem;margin-top: .25rem;margin-left: .1rem;}
  .ticket-group .item .m{font-size: .22rem;color: #333;}
  .ticket-group .item .r{width: 1.32rem;margin-left: .14rem;}
  .ticket-group .more{height: .88rem;font:.28rem/.88rem "Microsoft YaHei";color: #666;}
  .ticket-group .more img{width: auto;height: .14rem;margin-left:.08rem;vertical-align: middle;-webkit-transform: rotate(180deg);transform: rotate(180deg);-webkit-transition: all ease .3s;transition: all ease .3s;}
  .ticket-group.normal .more img{-webkit-transform: rotate(0deg);transform: rotate(0deg);}

  .route-box {position: relative;z-index: 1;padding: .4rem .24rem;}
  .route-type{margin-top: .3rem;overflow: auto;white-space: nowrap;}
  .route-box .type-item{position:relative;display:inline-block;height:.72rem;margin-right:.12rem;padding: 0 .24rem;text-align:center;font: .24rem/.72rem "Microsoft YaHei";color: #333;border: .02rem solid #fff;border-radius: .07rem;background: #fff;overflow: hidden;}
  .route-box .type-item.curr{border-color: #faaf39;background: #fffaf3;font-weight: bold;}
  .route-box .type-item img{display: none;position: absolute;bottom: -.1rem;right: -.08rem;z-index: 1;width: .34rem;height: .31rem;}
  .route-box .type-item.curr img{display: block;}
  .route-box .type-item:last-child{margin-right: 0;}
  .route-box .route-info{margin: .1rem 0;padding: .24rem;background: #fff;border-radius: .2rem;}
  .route-box .title{height: .42rem;}
  .route-box .title .name{max-width:70%;font: .32rem/.42rem "Microsoft YaHei";color: #222;}
  .route-box .title  .label{padding: 0 .09rem;margin-left: .08rem;margin-top:.06rem;font: .2rem/.3rem "Microsoft YaHei";color: #fff;background:#fa4f45;border-radius: .06rem;vertical-align: top;}
  .route-box .desc{margin-top: .2rem;}
  .route-box .desc .item{margin-top: .08rem;}
  .route-box .desc img{width: auto;height: .26rem;vertical-align: top;margin-top: .07rem;margin-right: .12rem;}
  .route-box .desc .name{margin-right:.1rem;font: .26rem/.4rem "Microsoft YaHei";color: #666;}
  .route-box .desc .r{font: .26rem/.4rem "Microsoft YaHei";color: #333;}
  .route-box .route-line{margin-top: .34rem;padding-top:.4rem;border-top: .02rem solid #e3e3e3;}
  .route-box .route-line .item{position:relative;padding-bottom: .4rem;}
  .route-box .route-line .item:after{content: '';position: absolute;top:0;bottom: 0;left: .17rem;width: .02rem;background: #dcdcdc;}
  .route-box .route-line .item:last-child:after{display: none;}
  .route-box .route-line .name{height: .36rem;color: #222;}
  .route-box .route-line .l{position: relative;z-index: 1;width: .36rem;height: .36rem;margin-right:.12rem;font: bold .2rem/.36rem "Microsoft YaHei";background:#faaf39;border-radius:50%;text-align: center;}
  .route-box .route-line .r{font: .3rem/.36rem "Microsoft YaHei";}
  .route-box .route-img{padding-left: .3rem;}
  .route-box .route-img img{float:left;margin-left:.15rem;width: 30%;height: auto;margin-top: .16rem;border-radius: .1rem;overflow: hidden;object-fit: cover;}
  .route-box .routeimg1 img{width: 80%;}
  .route-box .routeimg2 img{width: 45%;height: 1.96rem;}
  .route-box .routeimg3 img{width: 30%;}
  .route-box .line-txt{padding-left: .48rem;font: .26rem/.36rem "Microsoft YaHei";color: #666;margin-top: .1rem;}
  .route-box .route-tip{padding-left:.48rem;margin-top:.2rem;font: .26rem/.36rem "Microsoft YaHei";color: #999;}

  .guide-box{padding-left: .24rem;}
  .guide-box .title{margin: .4rem .24rem .4rem 0;}
  .guide-box .more{font: bold .28rem "Microsoft YaHei";color: #333;}
  .guide-box .more img{float:right;width: auto;height: .2rem;margin-top: .08rem;margin-left: .06rem;}
  .guide-list{width: 100%;height: 4.74rem;overflow: auto;white-space: nowrap;}
  .guide-item{position:relative;display:inline-block;width: 2.88rem;height: 4.64rem;margin-right:.16rem;border-radius: .13rem;background:#fff;overflow: hidden;}
  .guide-item .t-img{width: 100%;height: 3.4rem;border-radius: .13rem .13rem 0 0;overflow: hidden;}
  .guide-item .t-img img{float: left;width: 100%;height: 100%;object-fit: cover;object-position: top;}
  .guide-item .name{width:100%;height:.64rem;padding: .14rem .16rem .08rem;font: .3rem/.42rem "Microsoft YaHei";color: #333;}
  .guide-item .name .r{font: .2rem/.42rem "Microsoft YaHei";color: #666;}
  .guide-item .intro{width: calc(100% - .32rem);height: .32rem;margin:0 .16rem;background: #ffc600;font:.22rem/.32rem "Microsoft YaHei";color: #040101;border-radius: .04rem;}
  .guide-item .intro .l{margin-right:.06rem;padding-left:.08rem;padding-right: .16rem;font-weight:bold;color:#fff;background: url(../../assets/icon-jx.png) no-repeat;background-size: 100% 100%; }

  .comment-box{padding:.4rem .3rem;margin: .27rem .24rem 0;background: #fff;border-radius: .2rem;}
  .comment-item{margin-top: .4rem;}
  .comment-item:first-child{margin-top: .55rem;}
  .comment-item .l{width: .64rem;height: .64rem;margin-right: .14rem;border-radius: 50%;object-fit: cover;object-position: top;}
  .comment-item .intro{height: .64rem;font-size: .28rem;color: #333;}
  .comment-item .star{width: 100%;height: .23rem;margin-top: .06rem;}
  .comment-item .star img{float: left;width: auto;height: .23rem;margin-right: .1rem;}
  .comment-item .time{font-size: .24rem;color: #999;}
  .comment-item .desc{margin-top:.14rem;font: .28rem/.42rem "Microsoft YaHei";color: #333;min-height: .42rem;}
  .comment-item .comment-img{margin-top: .16rem;}
  .comment-item .img{float:left;width: 32.3%;height:1.8rem;margin-right: 1%;margin-bottom: 1%;border-radius: .2rem;object-fit:cover;overflow: hidden;}

  .fixed-bottom{position: fixed;left: 0;bottom:0;z-index:9;width: 100%;height: .98rem;padding: 0 .3rem;background: #fff;border-top:1px solid #e3e3e3;}
  .fixed-bottom .item-l{height: .92rem;font: .28rem/.92rem "Microsoft YaHei";color: #333;}
  .fixed-bottom .item-l:first-child{margin-right: .48rem;}
  .fixed-bottom .item-l img{float: left;width: auto;height: .32rem;margin-top: .3rem;margin-right: .08rem;}
  .fixed-bottom .btn-box{width: 48vw;height: .72rem;margin-top: .13rem;color:#fff;text-align:center;border-radius: .36rem;overflow: hidden;}
  .fixed-bottom .btn{float: left;width: 50%;height: 100%;font:.32rem/.72rem "Microsoft YaHei";border-radius: 0;}
  .fixed-bottom .btn1{background: #ffb500;}
  .fixed-bottom .btn2{background: #f06012;}
  .fixed-bottom .btn.disabled{ background: #e3e3e3;border: none;}

  .order-alert .alert-con{position: absolute;left: 0;bottom: 0;width: 100%;background: #fff;border-radius: .28rem .28rem 0 0;overflow: hidden;}
  .order-alert .icon-close{position: absolute;top:.43rem;right:.4rem;width: .28rem;height: .28rem;padding: 0;}
  .order-alert-top{padding-top:.3rem;padding-bottom: .2rem;border-bottom: 1px solid #e3e3e3;}
  .order-alert-top .t1{padding-left: .3rem;font-size: .32rem;color: #222;}
  .order-alert-top .t2{padding-left: .3rem;margin-top:.08rem;font-size: .24rem;color: #666;}
  .order-alert-mid{padding: 0 .26rem .4rem;max-height: 66vh;overflow-y: auto;}
  .order-alert-mid .tag-tit{padding-top:.4rem;padding-bottom:.14rem;font-size: .24rem;color: #333;}
  .order-alert-mid .tag-item{width: 1.95rem;height:.6rem;margin-right: .14rem;margin-top:.16rem;text-align: center;font: .26rem/.6rem "Microsoft YaHei";color: #333;border: .02rem solid #c3c3c3;border-radius: .3rem;}
  .order-alert-mid .tag-item.curr{background: #ffb500;border-color: #ffb500;}
  .order-alert-mid .tag-item.disabled{color: #fff;background: #e3e3e3;border: .02rem solid #e3e3e3;}
  .order-alert-bot{width: 100vw;height: .98rem;padding:0 .3rem;border-top:1px solid #e3e3e3;}
  .order-alert-bot .flex{font:bold .24rem/.98rem "Microsoft YaHei";color: #333;}
  .order-alert-bot .flex font{font-size: .36rem;}
  .order-alert-bot .btn{width:2.4rem;height:.72rem;margin-top: .14rem;margin-left:.55rem;font:.32rem/.72rem "Microsoft YaHei";border-radius: .4rem;}


</style>



// WEBPACK FOOTER //
// src/page/home/home.vue